import { useIntl } from "react-intl";
import useGlobalCachedResourceList from "src/api/useGlobalCachedResourceList";
import MuscleRegimeOptions from "src/utils/MuscleRegimeOptions";
import contentMessages from "src/pages/content/messages";
import { GeneralEntity } from "myfitworld-model";
import { Equipment } from "myfitworld-model/src";

const useContentFilterOptions = () => {
  const { formatMessage } = useIntl();
  const { data: MuscleGroupsOptions } = useGlobalCachedResourceList<GeneralEntity>("muscleGroupsCache");
  const { data: SportOptions } = useGlobalCachedResourceList<GeneralEntity>("sportsCache");
  const { data: MotorSkillsOptions } = useGlobalCachedResourceList<GeneralEntity>("motorSkillsCache");
  const { data: HealthIssueOptions } = useGlobalCachedResourceList<GeneralEntity>("healthIssuesCache");
  const { data: EquipmentOptions } = useGlobalCachedResourceList<Equipment>("equipmentCache");
  const { data: FitnessActivitiesOptions } = useGlobalCachedResourceList<GeneralEntity>("fitnessActivitiesCache");
  const { data: GoalsOptions } = useGlobalCachedResourceList<GeneralEntity>("goalsCache");
  const { data: GoodForOptions } = useGlobalCachedResourceList<GeneralEntity>("goodForCache");
  const { data: MealTypesOptions } = useGlobalCachedResourceList<GeneralEntity>("mealTypesCache");
  const { data: CounterProductiveForOptions } = useGlobalCachedResourceList<GeneralEntity>("counterProductiveForCache");
  const { data: TimePreparationOptions } = useGlobalCachedResourceList<GeneralEntity>("timePreparationCache");
  const { data: DietOptions } = useGlobalCachedResourceList<GeneralEntity>("dietCache");
  const { data: MicroNutrientOptions } = useGlobalCachedResourceList<GeneralEntity>("micronutrientCache");
  const { data: CategoryOptions } = useGlobalCachedResourceList<GeneralEntity>("categoryCache");
  const { data: GlycemicIndexRangeOptions } = useGlobalCachedResourceList<GeneralEntity>("glycemicIndexRangeCache");
  const { data: GlycemicLoadRangeOptions } = useGlobalCachedResourceList<GeneralEntity>("glycemicLoadRangeCache");
  const { data: DurationInWeeksOptions } = useGlobalCachedResourceList<GeneralEntity>("durationInWeeksCache");
  const { data: ExpertisesOptions } = useGlobalCachedResourceList<GeneralEntity>("expertisesCache");
  const muscleRegimeOptions = MuscleRegimeOptions.map((options) => ({
    id: options.value,
    name: {
      en: formatMessage((contentMessages as any)[options.label]),
      sr: formatMessage((contentMessages as any)[options.label]),
      de: formatMessage((contentMessages as any)[options.label]),
      es: formatMessage((contentMessages as any)[options.label]),
      hr: formatMessage((contentMessages as any)[options.label]),
    },
  }));
  return {
    MuscleGroupsOptions,
    SportOptions,
    MotorSkillsOptions,
    HealthIssueOptions,
    EquipmentOptions,
    FitnessActivitiesOptions,
    GoalsOptions,
    GoodForOptions,
    MealTypesOptions,
    CounterProductiveForOptions,
    TimePreparationOptions,
    DietOptions,
    MicroNutrientOptions,
    CategoryOptions,
    GlycemicIndexRangeOptions,
    GlycemicLoadRangeOptions,
    DurationInWeeksOptions,
    ExpertisesOptions,
    muscleRegimeOptions
  };
};
export default useContentFilterOptions;

export type AllContentFilterOptions = ReturnType<typeof useContentFilterOptions>;
